export default {
    // ----------Title----------
    document: '文件',
    generateFromDeliveryOrders: '创建(送货单生成)',
    scopeTheRangeOfTheCustomerProfiles: '确定客户档案的范围',
    dateRange: '日期范围',
    documentDateforDeliveryOrders: '交货单的文件日期',
    generateFromContainer: '创建(货柜生成)',
    basicInformationAboutTheDocument: '文件基本信息',

    cashCollection: '现金收款',
    optionalForCollectionUponDelivery: '可选择送货时付款',
    hubDistribution: '中心分发',
    deliveryDistributionLocations: '交货分发地点',
    relatedProfilesAttachedToDocument: '附带文件的相关档案',

    approvalStatus: '审核状态',
    relatedProfileInfoAttachedToDocument: '附带文件的相关文件',
    documentNo: '文件号',
    collection: '收集',
    distributeVia: '分配',
    placeBy: '下单',
    detailInformationAboutTheItemsInvolved: '物品详细信息',
    generateSingleInvoice: '生成单张发票',

    // -----------Drawer---------
    noPreviewInformation: '无预览信息',
    previewCharges: '预览信息',
    no: '序号',
    item: '物品',
    particulars: '具体内容',
    itemRate: '物品评级',
    chargeAmount: '收费金额',
    shippingRates: '运费率',
    totalSelected: '已选总数',
    documents: '文件',
    generateInvoiceNow: '生成发票',
    savedValidation: '已保存验证',
    newValidation: '添加验证',
    addNewValidation: '添加新验证',
    viewSavedValidation: '查看已保存验证',
    inventory: '库存',
    slot: '槽位',
    rack: '货架',
    availableQty: '可用数量',
    batchNo: '批号',
    expiryDate: '截止日期',
    storage: '存储',

    // -----------MUI-----------
    docNo: '文件号',
    docDate: '文件日期',
    doNumber: '送货单号',
    invoiceNo: '发票号',
    billingName: '付款人名称',
    billingAddress: '付款人地址',
    date: '日期',
    lastValidated: '验证时间',
    validation: '验证',
    generateFromDO: '创建(送货单生成)',
    documentDateFrom: '文件日期始于',
    documentDateTo: '文件日期至',
    startQuery: '开始查询',
    code: '编码',
    qty: '数量',
    loadFrom: '导入...',
    billTo: '账单至',
    shipTo: '发货至',
    subTotal: '小计',
    total: '总共',
    tax: '税',
    discount: '折扣',
    taxAmount: '税金额',
    totalAmount: '总金额',
    requiredAmount: '所需金额',
    collectedAmount: '已收集金额',
    distributionLocation: '配送地点',
    generateInvoices: '生成发票',
    marking: '唛头',
    validated: '已审核',
    pending: '待处理',
    balance: '平均',
    createdItemReceive: '已创建签收货物',
    containerLocation: '货柜位置',
    documentLocation: '文件位置',
}